// extracted by mini-css-extract-plugin
export default {"root":"app-portainer-home-EdgeLoadingSpinner-module__root"};